module.exports = __webpack_public_path__ + "img/banner-text-zh@3x.ded45138.png";